import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [SALES_HISTORY, SALES_HISTORY_SUCCESS, SALES_HISTORY_FAILURE] =
    createRequestActionTypes('chance/SALES_HISTORY');

export const listSalesHistory = createAction(SALES_HISTORY, (id) => id);
const listSalesHistorySaga = createRequestSaga(
    SALES_HISTORY,
    chanceApi.getHistory,
);

const UNLOAD_SALES_HISTORY = 'chance/UNLOAD_SALES_HISTORY';
export const unloadSalesHistory = createAction(UNLOAD_SALES_HISTORY);

export function* salesHistorySaga() {
    yield takeLatest(SALES_HISTORY, listSalesHistorySaga);
}

const initialState = {
    history: null,
    error: null,
};

const salesHistory = handleActions(
    {
        [SALES_HISTORY_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            history: data.list.map((com) => ({
                id: com.brdUuid,
                brdUuid: com.brdUuid,
                prjUuid: com.prjUuid,
                boUuid: com.boUuid,
                parentBrdUuid: com.parentBrdUuid,
                brdTxt: com.brdTxt,
                useYn: com.useYn,
                crtUsr: com.crtUsr,
                profileImg: com.profileImg,
                crtNm: com.crtNm,
                crtDt: com.crtDt,
            })),
            error: null,
        }),
        [SALES_HISTORY_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_SALES_HISTORY]: () => initialState,
    },
    initialState,
);

export default salesHistory;
